import * as $          from 'jquery';
import { onSubmit }     from 'Core/Events';
import {$body} from "Core/Body";

export const Newsletter = (() => {

    const Selector = {
        FORM:                         '#newsletter-form',
        NEWSLETTER_TITLE:             '.newsletter_banner-content--title',
        EMAIL:                        '#email',
        AGREEMENT:                    '#newsletter_agreement'
    };

    function sendNewsletterData(e) {
        e.preventDefault();
        const url = $(Selector.FORM).data('url');
        const emailSelector = $(Selector.FORM);
        const email = $(Selector.EMAIL).val();

        $.post(url, {email: email, newsletter_agreement: $(Selector.AGREEMENT).val()}).done(res=>{
            emailSelector.trigger('eventEdroneSaveToNewsletter', email);
            infoNewsletter('Dziękujemy za zapisanie się do newslettera');
        }).fail(() => {
            infoNewsletter('Błąd zapisu. Prosimy spróbować ponownie');
        });
    }

    function infoNewsletter(text) {
        $(Selector.FORM).empty();
        $(Selector.NEWSLETTER_TITLE).css('font-size', '20px').text(text)
    }

    $body.on('submit', Selector.FORM, sendNewsletterData);

    return true;
})();import * as $          from 'jquery';
import { onSubmit }     from 'Core/Events';
import {$body} from "Core/Body";

export const Newsletter = (() => {

    const Selector = {
        FORM:                         '#newsletter-form',
        NEWSLETTER_TITLE:             '.newsletter_banner-content--title',
        EMAIL:                        '#email',
        AGREEMENT:                    '#newsletter_agreement'
    };

    function sendNewsletterData(e) {
        e.preventDefault();
        const url = $(Selector.FORM).data('url');
        const emailSelector = $(Selector.FORM);
        const email = $(Selector.EMAIL).val();

        $.post(url, {email: email, newsletter_agreement: $(Selector.AGREEMENT).val()}).done(res=>{
            emailSelector.trigger('eventEdroneSaveToNewsletter', email);
            infoNewsletter('Dziękujemy za zapisanie się do newslettera');
        }).fail(() => {
            infoNewsletter('Błąd zapisu. Prosimy spróbować ponownie');
        });
    }

    function infoNewsletter(text) {
        $(Selector.FORM).empty();
        $(Selector.NEWSLETTER_TITLE).css('font-size', '20px').text(text)
    }

    $body.on('submit', Selector.FORM, sendNewsletterData);

    return true;
})();